export const isString = (str) => {
  if (typeof str !== 'string' || str.trim() === '') {
    throw new Error('Invalid value');
  }

  return str;
};

export const isNumber = (num) => {
  if (isNaN(Number(num))) {
    throw new Error('Invalid value');
  }

  return num;
};
